import React, {FC, useEffect, useState} from 'react';
import {PhoneNumberUtil} from 'google-libphonenumber';

interface IProps {
  id?: string;
  defaultCountryCode?: string;
  number: string;
  placeholder: string;
  onChange: (data: string) => void;
  disabled?: boolean;
  isValid?: boolean;
}

type CountryCodeType = string | number | undefined;

export const PhoneNumberInput: FC<IProps> = ({
  id,
  defaultCountryCode = 65, // Singapore
  number = '',
  placeholder = '',
  disabled = false,
  onChange,
  isValid = true,
}) => {
  const [countryCode, setCountryCode] = useState<CountryCodeType>();
  const [numberPart, setNumberPart] = useState<CountryCodeType>();

  useEffect(() => {
    let countryCodeCopy: CountryCodeType = defaultCountryCode;
    let numberPartCopy: CountryCodeType = number;

    if (number) {
      const rawNumber = number.replace(/\s|\+/g, '');

      try {
        const rawInput = PhoneNumberUtil.getInstance().parseAndKeepRawInput('+' + rawNumber);

        countryCodeCopy = rawInput.getCountryCode();
        numberPartCopy = rawInput.getNationalNumber();
      } catch (e) {
        countryCodeCopy = '';
      }
    }

    setCountryCode(countryCodeCopy);
    setNumberPart(numberPartCopy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCountryCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const countryCodeCopy = event.target.value.replace(/\D/g, '');
    setCountryCode(countryCodeCopy);
    changeNumber(countryCodeCopy, numberPart);
  };

  const onChangeNumberPart = (event: React.ChangeEvent<HTMLInputElement>) => {
    const numberPartCopy = event.target.value.replace(/\D/g, '');
    setNumberPart(numberPartCopy);
    changeNumber(countryCode, numberPartCopy);
  };

  const changeNumber = (code: CountryCodeType, numberPartCopy: CountryCodeType) => {
    if (numberPartCopy) {
      const numberCopy = `${code || ''}${numberPartCopy}`.trim();
      onChange(numberCopy);
    } else {
      onChange('');
    }
  };

  return (
    <>
      <div className="d-flex">
        <input
          type="text"
          className={`form-control px-0 text-center border-right-0 ${isValid ? '' : 'border border-danger'}`}
          style={{
            flexBasis: '50px',
            maxWidth: '50px',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          value={countryCode || ''}
          maxLength={4}
          onChange={onChangeCountryCode}
          placeholder="Code"
          disabled={disabled}
        />
        <input
          id={id ? id : undefined}
          type="text"
          className={`form-control ${isValid ? '' : 'border border-danger'}`}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
          value={numberPart || ''}
          onChange={onChangeNumberPart}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
    </>
  );
};
